import { render, staticRenderFns } from "./difficulty.vue?vue&type=template&id=9f2ebfc0&scoped=true&"
import script from "./difficulty.vue?vue&type=script&lang=js&"
export * from "./difficulty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2ebfc0",
  null
  
)

export default component.exports